import Link from 'next/link';
import { useRouter } from "next/router";
import ThongTinTongQuanUser from "components/tai-khoan/cai-dat/thong-tin-tong-quan";
import ThongTinTongQuanChuyenGia from "components/tai-khoan/cai-dat/thong-tin-tong-quan-chuyen-gia";
import DoiMatKhau from "components/tai-khoan/cai-dat/doi-mat-khau";
import SoDiaChi from "components/tai-khoan/cai-dat/so-dia-chi";
import QuanLyThongBao from "components/tai-khoan/cai-dat/quan-ly-thong-bao";
import HoTro from "components/tai-khoan/cai-dat/ho-tro";
import { getCookie } from "framework/libs/cookie";
import { TOKEN_CONGDONG } from "framework/store/constants";
import http from "utilities/http";
import { useEffect, useState } from "react";
import {isEmpty} from 'lodash';
import {Loader} from "components/loader";

export default function Account({ xaPhuong }) {
    const [user, setUser] = useState({});
    const [isProfessional, setIsProfessional] = useState(null);
    const [loading,setLoading] = useState(false);

    const route = useRouter();
    useEffect(() => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) route.push('/login');
    }, []);
    const fetchData = async () => {
        setLoading(true);
        const response = await Promise.all([
            http(`user`, null, { token: 'Bearer ' + getCookie(TOKEN_CONGDONG) }, 'v2'),
        ]);
        setUser(response[0]);
        setIsProfessional(response[0]?.is_professional);
        setLoading(false);
    };

    useEffect(() => fetchData(), []);

    const currentTab = route.query?.t || 'thong-tin-ho-so';
    const getActive = (menu) => {
        return (currentTab == menu ? "active" : "");
    };
    const tabContent = {
        'thong-tin-ho-so':  !isProfessional ?
            (<ThongTinTongQuanUser user={user}  fetchData={fetchData} xaPhuong={xaPhuong} setIsProfessional={setIsProfessional}></ThongTinTongQuanUser>) :
            (<ThongTinTongQuanChuyenGia user={user} fetchData={fetchData} xaPhuong={xaPhuong} setIsProfessional={setIsProfessional}></ThongTinTongQuanChuyenGia>),
        'doi-mat-khau': (<DoiMatKhau></DoiMatKhau>),
        'so-dia-chi': (<SoDiaChi></SoDiaChi>),
        'quan-ly-thong-bao': (<QuanLyThongBao></QuanLyThongBao>),
        'ho-tro': (<HoTro></HoTro>),
    };

    return(
        <section className="main main--accountViewProFile main-settingUser">
            {/* <div className="navView" style={{ position: 'inherit' }}> */}
            <Loader loading={loading} />
            <div className="wrap navView" style={{ position: 'inherit' }}>
                <ul>
                    <li>
                        <Link href={`?t=thong-tin-ho-so`}>
                            <a className={getActive("thong-tin-ho-so")}>Thông tin hồ sơ
                            </a>
                        </Link>
                    </li>
                    <li>
                        <Link href={`?t=doi-mat-khau`}>
                            <a className={getActive("doi-mat-khau")}>Đổi mật khẩu
                            </a>
                        </Link>
                    </li>
                    <li>
                        <Link href={`?t=so-dia-chi`}>
                            <a className={getActive("so-dia-chi")}>Sổ địa chỉ
                            </a>
                        </Link>
                    </li>
                    <li>
                        <Link href={`?t=quan-ly-thong-bao`}>
                            <a className={getActive("quan-ly-thong-bao")}>Quản lý thông báo
                            </a>
                        </Link>
                    </li>
                    <li>
                        <Link href={`?t=ho-tro`}>
                            <a className={getActive("ho-tro")}>Hỗ trợ
                            </a>
                        </Link>
                    </li>
                </ul>
            </div>
            {/* </div> */}

            <div className="wrap">
                <div className="wrap-row">
                    {/* <AccountInf user={user}/> */}
                    <div className="wrap-container setting-form">
                        {tabContent[currentTab]}
                    </div>
                </div>
            </div>
        </section>
    );
};

export async function getStaticProps(context) {
    const response = await Promise.all([
        http(`location?page=1&per_page=40`, null, {}, 'v2'),
        http(`location?page=2&per_page=40`, null, {}, 'v2')
    ]);

    let xaPhuong = [];
    if (response[0].code === 200 && response[1].code === 200) {
        xaPhuong = response[0].data.concat(response[1].data);
    }

    return {
        props: { xaPhuong },
    };
}